import { render, staticRenderFns } from "./BiCohortAnalysis.vue?vue&type=template&id=3968ef7e&"
import script from "./BiCohortAnalysis.vue?vue&type=script&lang=js&"
export * from "./BiCohortAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports